module.exports = __webpack_public_path__ + "img/lms-dashboard-student-background.8a3d792f.svg";